import { Component } from "@angular/core";
import { IAMAccountJwtVO, KeycloakAccountJwtVO } from "@common/domain";
import { AccountFacade } from "@youm-front/account/data-access";
import { AccountJwtService } from "@youm-front/account-jwt/data-access";
import { LeftMenuFacade } from "@youm-front/left-menu/data-access";
import { VERSION } from "@youm-front/utils/version";
import { map } from "rxjs/operators";

@Component({
  selector: "app-left-menu-feature-left-menu",
  templateUrl: "./left-menu.component.html",
  styleUrls: ["./left-menu.component.scss"]
})
export class LeftMenuComponent {
  readonly version = VERSION;

  constructor(
    private readonly accountFacade: AccountFacade,
    private readonly accountJwtService: AccountJwtService,
    private readonly leftMenuFacade: LeftMenuFacade
  ) {}

  get isOpen$() {
    return this.leftMenuFacade.isOpen$;
  }

  get withConsole$() {
    return this.accountJwtService.anyAccountJwtVO$.pipe(
      map(
        (_) =>
          _ instanceof KeycloakAccountJwtVO ||
          (_ instanceof IAMAccountJwtVO && _.value.isRoot)
      )
    );
  }

  onLogout() {
    this.accountFacade.signOut();
  }

  onOpen() {
    this.leftMenuFacade.open();
  }
}
